import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { handleBackendMessage, handleBackendErrorCode, renderToaster } from "../../common";
import { clearSnackbar } from "../../store/actions/SnackbarActions";

const GenericSnackbar = () => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const { successSnackbarMessage, successSnackbarOpen, errorSnackbarMessage, errorSnackbarOpen, infoSnackbarMessage, infoSnackbarOpen } = useSelector(({ snackbar }) => snackbar);

    useEffect(() => {
        if (successSnackbarOpen) {
            renderToaster(enqueueSnackbar, handleBackendMessage(successSnackbarMessage), "success");
        }
        if (errorSnackbarOpen) {
            // console.log(errorSnackbarMessage);

            const errorCode = handleBackendErrorCode(errorSnackbarMessage);
            if (errorCode.toString().startsWith("5")) {
                renderToaster(enqueueSnackbar, handleBackendMessage(errorSnackbarMessage), "error");
            } else {
                renderToaster(enqueueSnackbar, handleBackendMessage(errorSnackbarMessage), "warning");
            }
        }
        if (infoSnackbarOpen) {
            renderToaster(enqueueSnackbar, handleBackendMessage(infoSnackbarMessage), "info");
        }
        dispatch(clearSnackbar());
    }, [errorSnackbarOpen, successSnackbarOpen, infoSnackbarOpen]);

    return null;
};

export default GenericSnackbar;
